import { render, staticRenderFns } from "./ItemHistoryChangeTypeJson.vue?vue&type=template&id=23ac39dc&scoped=true"
import script from "./ItemHistoryChangeTypeJson.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac39dc",
  null
  
)

export default component.exports